import React from 'react';

export const RefTexts = {
  title: {
      ko: (
        <>
          사례
        </>
      ),
      en: (
        <>
          Reference
        </>
      )
  }
};

export const RefeFinancialTexts = {
  title: {
      ko: (
        <>
          금융
        </>
      ),
      en: (
        <>
          Financial
        </>
      )
  }
};


